function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/arrayWithHoles.js
// module id = 235
// module chunks = 1